import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Typography, Button, Box, ListItem } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GitHubIcon from "@mui/icons-material/GitHub";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ProjectDetailsDialog from "./ProjectDetailsDialog";

const ProjectListItem = ({ project }: any) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ListItem
      key={project.id}
      sx={{
        mb: 2,
        border: "1px solid #ddd",
        borderRadius: 1,
        p: 2,
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        gap: 2,
      }}
    >
      <Box sx={{ width: "50%", maxWidth: 400, position: "relative" }}>
        <img
          src={project.imageUrl[0]}
          alt={`${project.name}`}
          style={{
            width: "100%",
            height: "auto",
            borderRadius: 4,
            maxHeight: 200,
            objectFit: "cover",
          }}
        />
      </Box>
      <Box
        sx={{
          width: "50%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="h5"
          component="h3"
          sx={{ textTransform: "uppercase", mb: 1 }}
        >
          {project.name}
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          component="p"
          sx={{ mb: 2 }}
        >
          {project.description}
        </Typography>
        <Box sx={{}}>
          <Button
            size="small"
            variant="outlined"
            href={project.githubUrl}
            target="_blank"
            sx={{ mr: 1 }}
            startIcon={<GitHubIcon />}
          >
            {t("Source Code")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            href={project.projectLink}
            target="_blank"
            sx={{ mr: 1 }}
            startIcon={<VisibilityIcon />}
          >
            {t("Live Preview")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={handleOpen}
            startIcon={<MoreHorizIcon />}
          >
            {t("Learn More")}
          </Button>
        </Box>
      </Box>
      <ProjectDetailsDialog
        open={open}
        handleClose={handleClose}
        project={project}
      />
    </ListItem>
  );
};

export default ProjectListItem;
